var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news-panel"
  }, [_c("article-card", _vm._b({
    attrs: {
      articleList: _vm.articleList
    }
  }, "article-card", _vm.$attrs, false)), _c("footer", {
    staticClass: "news-panel__footer"
  }, [_c("a-pagination", {
    attrs: {
      "show-size-changer": "",
      "show-quick-jumper": "",
      pageSize: _vm.pageSize,
      total: _vm.total
    },
    on: {
      "update:pageSize": function ($event) {
        _vm.pageSize = $event;
      },
      "update:page-size": function ($event) {
        _vm.pageSize = $event;
      },
      change: _vm.handlePageChange,
      showSizeChange: _vm.handleSizeChange
    },
    model: {
      value: _vm.pageIndex,
      callback: function ($$v) {
        _vm.pageIndex = $$v;
      },
      expression: "pageIndex"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };